/*
 * The Bespoke Bibliophile — hover-note (42% trigger)
 *
 * For each product card that has a `[data-bb-hover-note]` element, roll a
 * probability check once per pageview. If it lands inside the threshold
 * (default 0.42), reveal the curator's note when the card is hovered or
 * keyboard-focused. The decision is cached on the element so it stays
 * consistent during the visit.
 *
 * 42% is a deep cut, not a number we explain on the page.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.__bbHoverNoteInit) return;
  window.__bbHoverNoteInit = true;

  const SELECTOR = '[data-bb-hover-note]';
  const ROLLED_ATTR = 'data-bb-rolled';
  const WIN_ATTR = 'data-bb-win';

  function decide(noteEl) {
    if (noteEl.getAttribute(ROLLED_ATTR) === '1') {
      return noteEl.getAttribute(WIN_ATTR) === '1';
    }
    const p = parseFloat(noteEl.getAttribute('data-bb-probability') || '0.42');
    const win = Math.random() < p;
    noteEl.setAttribute(ROLLED_ATTR, '1');
    noteEl.setAttribute(WIN_ATTR, win ? '1' : '0');
    return win;
  }

  function reveal(noteEl) {
    if (!decide(noteEl)) return;
    noteEl.classList.add('is-visible');
    noteEl.setAttribute('aria-hidden', 'false');
  }
  function hide(noteEl) {
    noteEl.classList.remove('is-visible');
    noteEl.setAttribute('aria-hidden', 'true');
  }

  function attach(noteEl) {
    if (noteEl.__bbBound) return;
    noteEl.__bbBound = true;
    const card = noteEl.closest('product-card') || noteEl.parentElement;
    if (!card) return;
    const onEnter = () => reveal(noteEl);
    const onLeave = () => hide(noteEl);
    card.addEventListener('pointerenter', onEnter);
    card.addEventListener('pointerleave', onLeave);
    card.addEventListener('focusin', onEnter);
    card.addEventListener('focusout', onLeave);
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  // Re-scan when Shopify re-renders sections (theme editor, cart drawer, etc.)
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
  document.addEventListener('shopify:block:select', (e) => scan(e.target));

  // Watch for new cards added by infinite scroll / quick filters
  const mo = new MutationObserver((muts) => {
    for (const m of muts) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(SELECTOR)) attach(node);
        if (node.querySelectorAll) scan(node);
      }
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
